module.exports = __webpack_public_path__ + "static/media/alimentos7.3f8fce6a.png";